<template>
    <div class="container">
        <!-- input for new todo -->
        <header>
            <p class="title">todo list</p>
            <div class="input__div">
                <div class="input__wrapper">
                    <input type="text" placeholder="another thing to be done" v-model="newTodo" @keyup.enter="addTodo">
                </div>
                <div class="border"></div>
            </div>
        </header>

        <!-- <section v-scroll-lock="true"> -->
        <section>
            <main>
                <!-- todo list -->
                <div class="todo-list">
                    <div v-for="todo in orderedTodos" :key="todo.id" class="list">
                        <!-- checkbox -->
                        <label class="material-checkbox">
                            <input type="checkbox" v-model="todo.completed" @click.once="toggleDone(todo)">
                            <span></span>
                        </label>

                        <!-- text box @swipeleft="deleteTodo(todo)" -->
                        <div class="text" :class="{completed: todo.completed}" v-if="!todo.editing">
                            <v-touch @doubletap="todo.editing=true; editTodoCache=todo.text" @swipeleft="deleteTodo(todo)" v-bind:swipe-options="{direction: 'horizontal'}" v-bind:enabled="{tap:true,pan:false,pinch:false,swipe:true,rotate: false}">
                                {{ todo.text }}
                            </v-touch>
                        </div>
                        <div class="input__div" v-else>
                            <div class="input__wrapper">
                                <input type="text" v-focus v-model="todo.text" @keyup.enter="editTodo(todo)" @keyup.esc="cancelEdit(todo)" @blur="editTodo(todo)">
                            </div>
                            <div class="border"></div>
                        </div>

                        <!-- priority indicator -->
                        <div>
                            <font-awesome-icon icon="angle-up" @click="prioUp(todo)" />
                            {{ todo.priority }}
                            <font-awesome-icon icon="angle-down" @click="prioDown(todo)" />
                        </div>
                    </div>
                </div>
            </main>
        </section>

        <footer>
            <!-- <span>left: {{ remaining }}</span> -->
            <div>
                <ul class="filters">
                    <li :class="{selected: visibility=='all'}" @click="setVisibility('all')"> All </li>
                    <li :class="{selected: visibility=='active'}" @click="setVisibility('active')">
                        <font-awesome-icon icon="list" size="lg" />
                    </li>
                    <li :class="{selected: visibility=='completed'}" @click="setVisibility('completed')">
                        <font-awesome-icon icon="check-square" size="lg" />
                    </li>
                </ul>
            </div>
            <span class="clear-completed" @click="showModal">
                <font-awesome-icon icon="tags" size="lg" />
            </span>
            <span class="clear-completed" @click="reload">
                <font-awesome-icon icon="sync-alt" size="lg" />
            </span>
            <!-- <span class="clear-completed" @click="removeCompleted" v-show="todos.length > remaining">
                <font-awesome-icon icon="trash-alt" size="lg"/>
            </span> -->
        </footer>

        <modals-container v-on:langsel="onSelect" />
    </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';

import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleUp,
    faAngleDown,
    faTrashAlt,
    faTrash,
    faCheck,
    faList,
    faCheckSquare,
    faTags,
    faSyncAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(
    faAngleUp,
    faAngleDown,
    faTrashAlt,
    faCheck,
    faCheckSquare,
    faList,
    faSyncAlt,
    faTags
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import modalComponent from './Modal.vue';

export default {
    name: 'TodoList',

    data() {
        return {
            visibility: 'all',
            newTodo: '',
            editTodoCache: '',
            json: '',
            todosId: 0,
            todos: [],
            last_id: -1,
            initialTodo: {
                id: 1,
                text: 'Your first todo - doubleclick to edit',
                completed: false,
                editing: false,
                priority: 1
            },
            tags: ['ray', 'bert']
        };
    },

    components: {
        modalComponent
    },

    created: function() {
        console.clear();
        this.getTodos();
    },

    watch: {
        todos: {
            handler: function(todos) {
                // console.log('this.editTodoCache [' + this.editTodoCache + ']');
                if (this.editTodoCache == '') {
                    // console.log('watcher');
                    this.saveTodos(todos);
                }
            },
            deep: true
        }
    },

    computed: {
        remaining() {
            return this.todos.filter(todo => !todo.completed).length;
        },

        orderedTodos: function() {
            let f;

            switch (this.visibility) {
                case 'active':
                    f = n => !n.completed;
                    break;
                case 'completed':
                    f = n => n.completed;
                    break;
                case 'all':
                    f = n => n;
                    break;
            }

            return _.chain(this.todos)
                .filter(f)
                .orderBy(['completed', 'priority'], ['asc', 'desc'])
                .value();
        }
    },

    methods: {
        beforeClose(e) {
            console.log('beforeclose', e);
        },
        onSelect(e) {
            console.log('yep', e);
        },
        showModal() {
            this.$modal.show(
                modalComponent,
                {
                    tags: this.tags
                },
                {
                    clickToClose: false
                }
            );
        },

        getTodos() {
            axios
                .get('/db-sqlite.php/kvstore/key/todos')
                .then(result => {
                    // console.log('kvstore get', result);
                    this.json = result.data[result.data.length - 1].value;
                    if (JSON.parse(this.json).length > 0) {
                        this.todos = JSON.parse(this.json);
                    } else {
                        this.todos.push(this.initialTodo);
                    }

                    // this.todos.forEach(element => {
                    //     if (element.priority == 0) element.priority = 1;
                    //     element.components = undefined;
                    // });

                    // get id of todo record
                    this.todosId = JSON.parse(
                        result.data[result.data.length - 1].id
                    );

                    // get last used id
                    if (this.todos.length > 0) {
                        this.last_id = Math.max.apply(
                            Math,
                            this.todos.map(function(o) {
                                return o.id;
                            })
                        );
                    } else {
                        this.last_id = 0;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        saveTodos() {
            // this.f.Datum = dayjs().format("YYYY-MM-DD HH:mm:ss");
            // store in kvstore database
            var newRow = {
                key: 'todos',
                value: JSON.stringify(this.todos)
            };
            axios
                .put('/db-sqlite.php/kvstore/' + this.todosId, newRow)
                .then(result => {
                    console.log('kvstore put', result.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        deleteTodo(todo) {
            console.log('delete');
            var index = this.getIndex(todo.id);
            this.todos.splice(index, 1);
        },
        addTodo() {
            if (this.newTodo.trim() == '') return;
            let todo = {
                id: ++this.last_id,
                text: this.newTodo,
                editing: false,
                completed: false,
                priority: 1
            };
            this.todos.push(todo);
            this.newTodo = '';
        },
        editTodo(todo) {
            if (todo.editing) {
                console.log('editTodo');
                todo.editing = false;
                if (todo.text.trim() == '') todo.text = this.editTodoCache;
                this.editTodoCache = '';
                // let editedTodo = _.clone(todo);
                // var index = this.getIndex(todo.id);
                // this.todos = JSON.parse(this.json);
                // this.todos[index] = editedTodo;
            }
        },
        cancelEdit(todo) {
            console.log('cancelEdit');
            todo.editing = false;
            todo.text = this.editTodoCache;
            // this.editTodoCache = '';
        },
        getIndex(id) {
            // return index for the given id
            return this.todos.map(e => e.id).indexOf(id);
        },
        toggleDone(todo) {
            todo.completed = !todo.completed;
        },
        prioUp(todo) {
            if (todo.priority < 5) todo.priority++;
        },
        prioDown(todo) {
            if (todo.priority > 1) todo.priority--;
        },
        setVisibility(item) {
            this.visibility = item;
        },
        reload() {
            location.reload(true);
        },
        removeCompleted() {}
    },

    directives: {
        focus: {
            inserted(el) {
                el.focus();
            }
        }
    }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.container {
    /* border: 1px solid yellow; */
    height: 100vh;
    display: flex;
    flex-direction: column;
    min-height: 300px;
    max-width: 600px;
    margin: 0px auto;
}

section {
    margin: 6px 0;
    flex-grow: 1;
    display: flex;
    overflow: scroll;
}

section main {
    overflow: auto;
    flex-grow: 1;
}

footer {
    padding: 10px 15px;
    background: #76dbae;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    height: 35px;
}

p.title {
    margin: 10px 0;
    font-size: 5rem;
    font-weight: 100;
    text-align: center;
}

.todo-list {
    padding: 8px 0;
}

.todo-list .list:hover {
    background: #f7fcfa;
}

.todo-list .list {
    display: flex;
    align-items: center;
    padding: 0 15px;
    /* height: 35px; */
}

.todo-list .list .text {
    /* padding: 0 8px; */
    /* height: 35px; */
    /* line-height: 35px; */
    margin: 6px 0;
    cursor: default;
    flex: 1;
}

.todo-list .list .text.completed {
    text-decoration: line-through;
}

.input__div {
    /* margin: 6px 0; */
    position: relative;
    border: 1px solid #e4f5ef;
    flex: 1;
}

.input__div:focus-within .input__wrapper {
    background: #fff;
}

.input__div .input__wrapper {
    background: #f7fcfa;
    padding: 0 15px;
    transition: background 0.3s;
}

.input__div .input__wrapper input {
    height: 35px;
    background: 0 0;
    border: none;
    color: #2c3e50;
    display: block;
    font-family: inherit;
    font-size: 16px;
    line-height: 16px;
    outline: 0;
    padding: 0;
    position: relative;
    width: 100%;
    z-index: 1;
}

.input__div .border {
    background: #42b983;
    transition: all 0.18s;
    bottom: -1px;
    height: 2px;
    left: 30%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    right: 30%;
}

.input__div:focus-within .border {
    left: 0;
    right: 0;
    opacity: 1;
}

.material-checkbox {
    position: relative;
    display: inline-block;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
    font-size: 14px;
    line-height: 18px;
}

.material-checkbox > input {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    position: absolute;
    z-index: -1;
    left: -5px;
    top: -5px;
    display: block;
    margin: 0;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    background-color: rgba(0, 0, 0, 0.42);
    outline: none;
    opacity: 0;
    transform: scale(1);
    -ms-transform: scale(0); /* Graceful degradation for IE */
    transition: opacity 0.5s, transform 0.5s;
}

.material-checkbox > input:checked {
    background-color: #2196f3;
}

.material-checkbox > input:disabled {
    opacity: 0;
}

.material-checkbox > input:disabled + span {
    cursor: initial;
}

.material-checkbox > span::before {
    content: '';
    display: inline-block;
    margin-right: 15px;
    border: solid 2px rgba(0, 0, 0, 0.42);
    border-radius: 2px;
    width: 14px;
    height: 14px;
    vertical-align: -4px;
    transition: border-color 0.5s, background-color 0.5s;
}

.material-checkbox > input:checked + span::before {
    border-color: #41b883;
    background-color: #41b883;
}

.material-checkbox > input:active + span::before {
    border-color: #41b883;
}

.material-checkbox > input:checked:active + span::before {
    border-color: transparent;
    background-color: rgba(0, 0, 0, 0.42);
}

.material-checkbox > span::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 10px;
    border: solid 2px transparent;
    border-left: none;
    border-top: none;
    transform: translate(5.5px, 1px) rotate(45deg);
    -ms-transform: translate(5.5px, 2px) rotate(45deg);
}

.material-checkbox > input:checked + span::after {
    border-color: #fff;
}
.filters {
    margin: 0;
    padding: 0;
    list-style: none;
}

.filters li {
    display: inline;
    cursor: pointer;
    color: inherit;
    margin: 3px;
    padding: 3px 7px;
    text-decoration: none;
    border: 1px solid transparent;
    border-radius: 3px;
}

.filters li:hover {
    border-color: rgba(175, 47, 47, 0.1);
}

.filters li.selected {
    border-color: rgba(175, 47, 47, 0.2);
}

.clear-completed {
    float: right;
    text-decoration: none;
    cursor: pointer;
}

.clear-completed:hover {
    text-decoration: underline;
}
</style>